import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';
import Content from './Content';
import useCompany from './useCompany';

interface Props {
  companyId: string;
  onClose: () => void;
}

const DCFRawDataModal = ({ companyId, onClose }: Props) => {
  const { data, status, isError } = useCompany(companyId);
  return (
    <Modal
      title="Share Price vs. Fair Value"
      isLoading={status === 'pending'}
      primaryLabel="Close"
      onPrimaryClick={onClose}
      onClose={onClose}
    >
      <>
        {isError && <p>Something went wrong. Please try again later</p>}
        {typeof data !== 'undefined' && (
          <Content
            uniqueSymbol={data.uniqueSymbol}
            reportingCurrencyISO={data.reportingCurrencyISO}
            reportingCurrencySymbol={data.reportingCurrencySymbol}
            primaryTradingCurrecyISO={data.primaryTradingItemCurrencyISO}
            primaryTradingCurrencySymbol={data.primaryTradingItemCurrencySymbol}
            tradingItemCurrencyISO={data.tradingItemCurrencyISO}
            tradingItemCurrencySymbol={data.tradingItemCurrencySymbol}
            lastEarningsUpdate={data.lastEarningsUpdateAnnual}
            analystCount={data.analystCount}
            analystFcfCountAverage={data.analystFcfCountAverage}
            companyShortName={data.name}
            exchangeSymbol={data.exchangeSymbol}
            tickerSymbol={data.tickerSymbol}
            exchangeCountryISO={data.exchangeCountryISO}
            listingPrice={data.lastSharePrice}
            industrySecondaryName={data.industrySecondaryName}
            relativeListingSharesOutstanding={
              data.relativeListingSharesOutstanding
            }
            model={data.model}
            unleveredBeta={data.unleveredBeta}
            de={data.de}
            taxRate={data.taxRate}
            equityPremium={data.equityPremium}
            riskFreeRate={data.riskFreeRate}
            leveredBetaActual={data.leveredBetaActual}
            leveredBeta={data.leveredBeta}
            costOfEquity={data.costOfEquity}
            adrPerShare={data.adrPerShare}
            pv5y={data.pv5y}
            pvtv={data.pvtv}
            terminalValue={data.terminalValue}
            npv={data.npv}
            npvPerShare={data.npvPerShare}
            npvPerShareReportedCurrency={data.npvPerShareReportedCurrency}
            intrinsicDiscount={data.intrinsicDiscount}
            excessReturns={data.excessReturns}
            twoStagefcf={data.twoStagefcf}
            REIT={data.REIT}
            dividendDiscount={data.dividendDiscount}
            primaryListingExchangeSymbol={data.primaryListingExchangeSymbol}
            primaryListingTickerSymbol={data.primaryListingTickerSymbol}
          />
        )}
      </>
    </Modal>
  );
};

export default track({
  type: 'track',
  subject: 'DCFRawDataModal',
})(DCFRawDataModal) as typeof DCFRawDataModal;
